import React, { FC } from "react"
import { NumberFormatValues, NumericFormat, SourceInfo } from "react-number-format"
import { Stack, SxProps, TextField, Theme, Typography } from "@mui/material"
import { STAKING, UNSTAKING } from "@/utils/constants"
import { StakingSelectItem } from "@/components/staking/components/detail/types"
import useTrans from "@/hooks/useTrans"
import useRestaking from "@/hooks/useRestaking"
import * as styles from "./styles"

type RelendInputProps = {
  value?: number | undefined
  setValue: React.Dispatch<React.SetStateAction<number | undefined>>
  disabled?: boolean
  selectedStakingItem: StakingSelectItem
  tokenBalance?: number
  type: typeof STAKING | typeof UNSTAKING
  onValueChange: (values: NumberFormatValues, sourceInfo: SourceInfo) => void
}

const View: FC<RelendInputProps> = ({
  value,
  setValue,
  disabled,
  selectedStakingItem,
  tokenBalance,
  type,
  onValueChange,
}) => {
  const trans = useTrans()
  const { stakedAmountUI } = useRestaking()

  const isStaking = type === STAKING
  const handleChangeMax = () => {
    const maxValueToSet = isStaking ? tokenBalance : stakedAmountUI
    setValue(maxValueToSet)
  }

  const maxTextDisabled: SxProps<Theme> = !disabled
    ? {
        "&:hover": {
          color: "unset",
          cursor: "not-allowed",
        },
      }
    : {}

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      className='py-[10px] px-4 rounded-lg border border-solid border-neutral-200'
      sx={styles.wrapper}
    >
      <NumericFormat
        customInput={TextField}
        sx={{
          ...styles.inputBox,
        }}
        value={value}
        onValueChange={onValueChange}
        decimalScale={selectedStakingItem.decimals}
        thousandSeparator=','
        decimalSeparator='.'
        placeholder='0.00'
        disabled={disabled}
        allowNegative={false}
        data-testid='restaking-modal-amount-input'
        inputProps={{
          className: "text-neutral-1000 text-base sm:text-lg font-medium",
        }}
      />
      <Typography
        className='text-sm text-primary underline cursor-pointer hover:text-primary/80'
        data-testid='restaking-modal-amount-max'
        sx={{
          ...maxTextDisabled,
        }}
        onClick={() => {
          if (!disabled) {
            handleChangeMax()
          }
        }}
      >
        {trans.dashboard.modal.max}
      </Typography>
    </Stack>
  )
}

export default View
